import router from '@router'
const handleUserNotLogged = ({ code, status }) => async dispatch => {
    if (status === 403 && code === 'USER_NOT_LOGGED') {
        await dispatch('auth/userNotLogged', null, { root: true })
        router.push({ name: 'login' })
    }
}

export default handleUserNotLogged
